import React from 'react'
import Responsive from 'react-responsive'
import { sizes } from 'themes'

const Mobile = props => <Responsive {...props} maxWidth={sizes.tablet} />

export { Mobile }
